<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.activityId" class="input-with-select" size="small">
                        <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>                            
                        </el-select>
                    </el-input>
                </el-col>                
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/home/event/edit')" type="primary" icon="el-icon-plus" size="small"  @click="$refs.add.show()">创建营销短信</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="name" label="短信名称" show-overflow-tooltip min-width="200"></el-table-column>
				<el-table-column prop="activityId" label="营销演出ID" min-width="150"></el-table-column>
				<el-table-column prop="activityTitle" label="营销演出名称" min-width="200" show-overflow-tooltip></el-table-column>               
                <el-table-column  label="营销圈层/发送人数" min-width="150">
					<template slot-scope="scope">
						圈层1：{{scope.row.circleNum1}}<p>圈层2： {{scope.row.circleNum2}}</p><p>圈层3： {{scope.row.circleNum3}}</p>
					</template>
				</el-table-column>                
                <el-table-column prop="successUserNum" label="成功触达人数" min-width="150" ></el-table-column>
				<el-table-column prop="linkPv" label="短链点击pv/uv" min-width="200" >
					<template slot-scope="scope">
					    <p>PV：{{`${scope.row.linkPv || 0 }`}}</p>
					    <p>UV：{{`${scope.row.linkUv || 0 }`}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="detailPv" label="浏览演出详情 pv/uv" min-width="200" >
					<template slot-scope="scope">
						<p>PV：{{`${scope.row.detailPv || 0 }`}}</p>
						<p>UV：{{`${scope.row.detailUv || 0 }`}}</p>
					</template>
				</el-table-column>
				<el-table-column  label="订单数">
					<template slot-scope="scope">
						<p>{{`${scope.row.orderNum || 0 }`}}</p>
					</template>
				</el-table-column>
				<el-table-column label="下单人数">
					<template slot-scope="scope">
						<p>{{`${scope.row.orderUserNum || 0 }`}}</p>
					</template>
				</el-table-column>
				<el-table-column  label="下单金额">
					<template slot-scope="scope">
						<p>{{`${scope.row.orderAmount || '0.00' }`}}</p>
					</template>
				</el-table-column>				
				<el-table-column prop="createTime" label="创建时间" min-width="200" ></el-table-column>
                <el-table-column fixed="right" label="操作" min-width="200">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/smsMarketing/detail')" type="text" size="small" @click="$refs.add.show(row.id)" >详情</el-button>
						<el-button v-if="$utils.have('/smsMarketing/data')" type="text" size="small" @click="statistics(row.id)" icon="el-icon-s-data">数据</el-button>
						<el-button v-if="$utils.have('/smsMarketing/del')" type="text" size="small" @click="del(row.id)" icon="el-icon-delete">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
			<add ref="add" @onUpdate="getDataList()"></add>
        </div>
    </div>
</template>
<script>
import Add from './components/add.vue'
const defaultParams = {
    pageNo: 1,  
    activityId: ""
}
export default {
	components:{Add},
    data(){
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),               
                activityId: this.$route.query.searchValue || "",
                
            },
            listLoading: true,
            searchType:1
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/smsMarketing/list",
                method: "get",
                params: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		statistics(id){
			this.$router.push({
			    path: `/smsmarketing/sendmessage/statistics/${id}`,
			});
		},
		
       // 删除
		del(id){
			var _id = id
           this.$confirm('确认要删除营销短信吗？', '提示', {
               confirmButtonText: '确认删除',
               cancelButtonText: '暂不删除',
               type: 'warning',
               center: true,
               closeOnClickModal: false
           }).then(()=> {
               this.$request({
                   url: "/smsMarketing/del",
                   method: "POST",
                   params:{
                       id: _id
                   }
               }).then(res=> {
                   const { state, msg, result } = res.data;
                   if (state && state == 1 ) {
                       this.$message.success("删除成功");
                        this.getDataList();
                   } else {
                       return this.$message.error(msg || "删除失败");
                   }
               })
           }).catch(()=> {}) 
       },
    }
}
</script>

<style lang="scss" scoped>

</style>